import { render, staticRenderFns } from "./Boarding.vue?vue&type=template&id=9331ba0c&"
import script from "./Boarding.vue?vue&type=script&lang=js&"
export * from "./Boarding.vue?vue&type=script&lang=js&"
import style0 from "./Boarding.vue?vue&type=style&index=0&id=9331ba0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports